import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import i18n from './locales'
import { addDynamicRoutes } from './router/dynamic'
import { useAppStore } from '@/stores/app'

import '@/assets/styles/main.scss'
import { createHead } from '@vueuse/head'

async function bootstrap() {
    const app = createApp(App)

    // 在挂载应用前预加载动态路由，确保首次导航即可匹配到正确页面
    try {
        await addDynamicRoutes(router)
    } catch (error) {
        console.error('[Bootstrap] Failed to preload dynamic routes:', error)
    }

    app.use(createHead())
    app.use(createPinia())
    app.use(router)
    app.use(i18n)

    // 挂载前加载全局 SEO 配置，确保页面渲染时 meta 标签已有值
    try {
        await useAppStore().initSeoConfig()
    } catch (error) {
        console.error('[Bootstrap] Failed to load seo config:', error)
    }

    // 等待初始路由解析完成后再挂载，避免过渡闪烁
    await router.isReady()

    app.mount('#app')
}
bootstrap()
